import { Link } from 'react-router-dom';
import { Button } from '../components/ui';
import { Icon } from '../components/Icon';

export function NotFoundPage() {
  return (
    <div className="flex min-h-dvh flex-col items-center justify-center bg-slate-50 p-6 text-center">
      <span className="flex h-16 w-16 items-center justify-center rounded-2xl bg-slate-100 text-slate-400">
        <Icon name="alert" className="h-8 w-8" />
      </span>
      <h1 className="mt-4 text-2xl font-bold text-slate-900">Page not found</h1>
      <p className="mt-1 text-sm text-slate-500">The page you are looking for does not exist.</p>
      <Link to="/" className="mt-6">
        <Button size="lg">Go to home</Button>
      </Link>
    </div>
  );
}